/**
 * Adapted from https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 * @returns {string} the OS that is running the browser
 * @example 'Windows 10'
 */
export const getOS = () => {
  if (!window || !window.navigator || !window.navigator.userAgent) return 'Unknown'
  if (window.navigator.userAgent.indexOf('Windows NT 10.0') !== -1) return 'Windows 10'
  else if (window.navigator.userAgent.indexOf('Windows NT 6.2') !== -1) return 'Windows 8'
  else if (window.navigator.userAgent.indexOf('Windows NT 6.1') !== -1) return 'Windows 7'
  else if (window.navigator.userAgent.indexOf('Windows NT 6.0') !== -1) return 'Windows Vista'
  else if (window.navigator.userAgent.indexOf('Windows NT 5.1') !== -1) return 'Windows XP'
  else if (window.navigator.userAgent.indexOf('Windows NT 5.0') !== -1) return 'Windows 2000'
  else if (window.navigator.userAgent.indexOf('userAgentMatchac') !== -1) return 'userAgentMatchac/iOS'
  else if (window.navigator.userAgent.indexOf('X11') !== -1) return 'UNIX'
  else if (window.navigator.userAgent.indexOf('Linux') !== -1) return 'Linux'
  return 'Unknown'
}

/**
 * Adapted from https://stackoverflow.com/questions/5916900/how-can-you-detect-the-version-of-a-browser
 * TODO: Perhaps convert to use bowser, but at the expense of build time and bundle size, is it really worth it?
 * @returns {object} the name of the browser with the version appended at the end
 * @example {name:'Chrome, version: 42'}
 */
export const getBrowser = () => {
  let ua = navigator.userAgent,
    tem,
    userAgentMatch = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
  if (/trident/i.test(userAgentMatch[1])) {
    const versionMatch = /\brv[ :]+(\d+)/g.exec(ua) || []
    return { name: 'IE', version: (versionMatch[1] || '') }
  }
  if (userAgentMatch[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
    if (tem !== null) return { name: tem[1].replace('OPR', 'Opera'), version: tem[2] }
  }
  userAgentMatch = userAgentMatch[2] ? [userAgentMatch[1], userAgentMatch[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) !== null)
    userAgentMatch.splice(1, 1, tem[1])
  return { name: userAgentMatch[0], version: userAgentMatch[1] }
}